import { parkingStatusMessages } from 'src/features/monitoring/utils/messages';
import { POSITION } from 'src/features/systems/utils/types';

export enum MonitoringCurrentScreen {
    HOME = 'HOME',
    VISITORS_SEARCH = 'VISITORS_SEARCH',
    ACTIVE_STAY_PAYMENT_OPTIONS = 'ACTIVE_STAY_PAYMENT_OPTIONS',
    ACTIVE_STAY_CARD_PAYMENT = 'ACTIVE_STAY_CARD_PAYMENT',
    ACTIVE_STAY_CASH_PAYMENT = 'ACTIVE_STAY_CASH_PAYMENT',
    ACTIVE_STAY_ONLINE_PAYMENT = 'ACTIVE_STAY_ONLINE_PAYMENT',
    ACTIVE_STAY_PAYMENT_SUCCESSFUL = 'ACTIVE_STAY_PAYMENT_SUCCESSFUL',
    CHOOSE_LANGUAGE = 'CHOOSE_LANGUAGE',
    HELP = 'HELP',
    SETTINGS = 'SETTINGS',
    FISCAL_SERVICES = 'FISCAL_SERVICES',
    COIN_SERVICES = 'COIN_SERVICES',
    BANKNOTE_SERVICES = 'BANKNOTE_SERVICES',
    SYSTEM_INFORMATION = 'SYSTEM_INFORMATION',
    SUBSCRIPTION_SEARCH = 'SUBSCRIPTION_SEARCH',
    SUBSCRIPTION_PLANS = 'SUBSCRIPTION_PLANS',
    SUBSCRIPTION_DETAILS = 'SUBSCRIPTION_DETAILS',
    SUBSCRIPTION_START = 'SUBSCRIPTION_START',
    SUBSCRIPTION_CASH_PAYMENT = 'SUBSCRIPTION_CASH_PAYMENT',
    SUBSCRIPTION_CARD_PAYMENT = 'SUBSCRIPTION_CARD_PAYMENT',
    SUBSCRIPTION_PAYMENT_SUCCESSFUL = 'SUBSCRIPTION_PAYMENT_SUCCESSFUL',
    SUBSCRIPTION_OPTIONS = 'SUBSCRIPTION_OPTIONS',
    CASH_SERVICES = 'CASH_SERVICES',
    FISCAL_NOTE_QR = 'FISCAL_NOTE_QR',
    SUBSCRIPTION_PAYMENT_OPTIONS = 'SUBSCRIPTION_PAYMENT_OPTIONS',
}

export const MonitoringCurrentScreenMap = {
    [MonitoringCurrentScreen.HOME]: parkingStatusMessages.home,
    [MonitoringCurrentScreen.VISITORS_SEARCH]: parkingStatusMessages.visitorsSearch,
    [MonitoringCurrentScreen.ACTIVE_STAY_PAYMENT_OPTIONS]: parkingStatusMessages.activeStayPaymentOptions,
    [MonitoringCurrentScreen.ACTIVE_STAY_CARD_PAYMENT]: parkingStatusMessages.activeStayCardPayment,
    [MonitoringCurrentScreen.ACTIVE_STAY_CASH_PAYMENT]: parkingStatusMessages.activeStayCashPayment,
    [MonitoringCurrentScreen.ACTIVE_STAY_ONLINE_PAYMENT]: parkingStatusMessages.activeStayOnlinePayment,
    [MonitoringCurrentScreen.ACTIVE_STAY_PAYMENT_SUCCESSFUL]: parkingStatusMessages.activeStayPaymentSuccessful,
    [MonitoringCurrentScreen.CHOOSE_LANGUAGE]: parkingStatusMessages.chooseLanguage,
    [MonitoringCurrentScreen.HELP]: parkingStatusMessages.help,
    [MonitoringCurrentScreen.SETTINGS]: parkingStatusMessages.settings,
    [MonitoringCurrentScreen.FISCAL_SERVICES]: parkingStatusMessages.fiscalServices,
    [MonitoringCurrentScreen.COIN_SERVICES]: parkingStatusMessages.coinServices,
    [MonitoringCurrentScreen.BANKNOTE_SERVICES]: parkingStatusMessages.banknoteServices,
    [MonitoringCurrentScreen.SYSTEM_INFORMATION]: parkingStatusMessages.systemInformation,
    [MonitoringCurrentScreen.SUBSCRIPTION_SEARCH]: parkingStatusMessages.subscriptionSearch,
    [MonitoringCurrentScreen.SUBSCRIPTION_PLANS]: parkingStatusMessages.subscriptionPlans,
    [MonitoringCurrentScreen.SUBSCRIPTION_DETAILS]: parkingStatusMessages.subscriptionDetails,
    [MonitoringCurrentScreen.SUBSCRIPTION_START]: parkingStatusMessages.subscriptionStart,
    [MonitoringCurrentScreen.SUBSCRIPTION_CASH_PAYMENT]: parkingStatusMessages.subscriptionCashPayment,
    [MonitoringCurrentScreen.SUBSCRIPTION_CARD_PAYMENT]: parkingStatusMessages.subscriptionCardPayment,
    [MonitoringCurrentScreen.SUBSCRIPTION_PAYMENT_SUCCESSFUL]: parkingStatusMessages.subscriptionPaymentSuccessful,
    [MonitoringCurrentScreen.SUBSCRIPTION_OPTIONS]: parkingStatusMessages.subscriptionOptions,
    [MonitoringCurrentScreen.FISCAL_NOTE_QR]: parkingStatusMessages.fiscalNoteQr,
    [MonitoringCurrentScreen.SUBSCRIPTION_PAYMENT_OPTIONS]: parkingStatusMessages.subscriptionPaymentOptions,
    [MonitoringCurrentScreen.CASH_SERVICES]: parkingStatusMessages.cashServices,
};

/** Row label for a gateway's occupancy sensor, by position. Distinct from the bare
 *  POSITION_TRANSLATIONS_MAP used in the component forms: on the monitoring card each loop is its
 *  own attribute, so the label has to name the thing ("Front loop") and not just the place ("Front"). */
export const LOOP_POSITION_TRANSLATIONS_MAP = {
    [POSITION.FRONT]: parkingStatusMessages.frontLoop,
    [POSITION.CENTER]: parkingStatusMessages.centerLoop,
    [POSITION.BACK]: parkingStatusMessages.backLoop,
};
